import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../../../../../services/toast.service';
import {standardAssignmentErrorKey} from 'app/services/standard-assignment-error';

const EMPLOYEE_STANDARD_SAVE_SUCCESS_KEY = 'EMPLOYEE_STANDARD_OVERRIDES_SAVE_SUCCESS';
const EMPLOYEE_STANDARD_SAVE_ERROR_KEY = 'EMPLOYEE_STANDARD_OVERRIDES_SAVE_ERROR';
const EMPLOYEE_STANDARD_LOAD_ERROR_KEY = 'EMPLOYEE_STANDARD_OVERRIDES_LOAD_ERROR';
const EMPLOYEE_STANDARD_NO_SELECTION_KEY = 'EMPLOYEE_STANDARD_OVERRIDES_NO_EMPLOYEES_SELECTED';
const EMPLOYEE_STANDARD_ACCESS_DENIED_KEY = 'EMPLOYEE_STANDARD_OVERRIDES_ACCESS_DENIED';
const EMPLOYEE_STANDARD_USER_NOT_IN_GROUP_KEY = 'EMPLOYEE_STANDARD_OVERRIDES_USER_NOT_IN_GROUP';
const EMPLOYEE_STANDARD_HEAD_DEPUTY_ONLY_KEY = 'EMPLOYEE_STANDARD_OVERRIDES_HEAD_DEPUTY_ONLY';
const EMPLOYEE_STANDARD_ACCESS_DENIED_CODE = 'ACCESS_DENIED';
const EMPLOYEE_STANDARD_USER_NOT_IN_GROUP_CODE = 'USER_NOT_IN_GROUP';
const EMPLOYEE_STANDARD_HEAD_DEPUTY_ONLY_CODE = 'HEAD_DEPUTY_ONLY';

@Injectable()
export class EmployeeStandardOverridesNotificationService {
  constructor(
    private readonly toastService: ToastService,
    private readonly translate: TranslateService
  ) {}

  public showNoSelection(): void {
    this.showError(EMPLOYEE_STANDARD_NO_SELECTION_KEY);
  }

  public showLoadError(error: HttpErrorResponse): void {
    this.toastService.error(this.resolveErrorMessage(error, EMPLOYEE_STANDARD_LOAD_ERROR_KEY));
  }

  public showSaveSuccess(): void {
    this.toastService.success(this.translate.instant(EMPLOYEE_STANDARD_SAVE_SUCCESS_KEY));
  }

  public showSaveError(error: HttpErrorResponse): void {
    this.toastService.error(this.resolveErrorMessage(error, EMPLOYEE_STANDARD_SAVE_ERROR_KEY));
  }

  private resolveErrorMessage(error: HttpErrorResponse, fallbackKey: string): string {
    const assignmentError = standardAssignmentErrorKey(error);
    if (assignmentError) { return this.translate.instant(assignmentError); }
    if (this.hasPlainErrorMessage(error)) {
      return error.error.trim();
    }
    if (this.resolveStructuredErrorKey(error)) {
      return this.translate.instant(this.resolveStructuredErrorKey(error));
    }
    return this.translate.instant(fallbackKey);
  }

  private hasPlainErrorMessage(error: HttpErrorResponse): boolean {
    return !!error && typeof error.error === 'string' && error.error.trim().length > 0;
  }

  private resolveStructuredErrorKey(error: HttpErrorResponse): string {
    if (!this.hasStructuredErrorCode(error)) {
      return '';
    }
    return this.resolveErrorCodeKey(error.error.errorCode);
  }

  private hasStructuredErrorCode(error: HttpErrorResponse): boolean {
    return !!error &&
      !!error.error &&
      typeof error.error === 'object' &&
      typeof error.error.errorCode === 'string' &&
      error.error.errorCode.trim().length > 0;
  }

  private resolveErrorCodeKey(errorCode: string): string {
    if (errorCode === EMPLOYEE_STANDARD_ACCESS_DENIED_CODE) {
      return EMPLOYEE_STANDARD_ACCESS_DENIED_KEY;
    }
    if (errorCode === EMPLOYEE_STANDARD_USER_NOT_IN_GROUP_CODE) {
      return EMPLOYEE_STANDARD_USER_NOT_IN_GROUP_KEY;
    }
    if (errorCode === EMPLOYEE_STANDARD_HEAD_DEPUTY_ONLY_CODE) {
      return EMPLOYEE_STANDARD_HEAD_DEPUTY_ONLY_KEY;
    }
    return '';
  }

  private showError(messageKey: string): void {
    this.toastService.error(this.translate.instant(messageKey));
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/popups/employee-standard-overrides/services/employee-standard-overrides-notification.service.ts